module.exports = __webpack_public_path__ + "img/Terfens.52a11e5b.jpg";